
import {
    html, customElement, property,
} from 'lit-element';

import {
    shouldFetchTeamCourses,
    isFetchingTeamCourses,
} from 'Selectors/Team';

import {
    getTeams,
} from 'Selectors/User';

import TeamActions from 'Actions/Team';
import { getOrganization, updateOrganization } from 'Actions/Organization'

import { editOrganization } from './Factories/EditOrganization';
import { viewOrganization } from './Factories/ViewOrganization';

import { ConnectedComponent } from 'Components/Global/ConnectedComponent';
import 'Components/Global/SifiveDropdown';
import 'Components/Global/SifiveLoader';

import { getStyles } from './Styles';
import 'Components/Global/SVGIcon';

/**
 * OrgManagerDashboard LitElement
 * template
 */
@customElement('org-manager-dashboard')
class OrgManagerDashboard extends ConnectedComponent {

    @property({ type: Boolean })
    isFetching = false;

    @property({ type: Object })
    teams = false;

    @property({ type: Object })
    editMode = false;

    @property({ type: Object })
    editState = {}

    // If the user wants to "Discard Changes", update with this data
    @property({ type: Object })
    editModeBackup = {}

    @property({ type: Object })
    orgData = {}

    /**
     * @return {String} element styles
     */
    static get styles() {

        return getStyles(this);

    }

    setEditMode(mode) {
        this.editMode = mode
        if (this.editMode) {
            this.editModeBackup = {
                ...this.orgData
            }
        }
    }

    fetchOrgManagerDashboardData() {
        try {
            const state = this.store.getState()
            const orgFromUser = state.User.CurrentUser.teams[0].organization
            const { id } = orgFromUser
            this.orgData = state.Organization[id] || orgFromUser
            // this.store.dispatch(getOrganization(this.orgData.id))
        } catch (err) {
            console.error('No org data', err)
        }
    }

    connectedCallback() {
        super.connectedCallback()
        this.fetchOrgManagerDashboardData()
    }

    discardChanges(event) {

        this.orgData = {
            ...this.editModeBackup
        }
        this.store.dispatch(updateOrganization(this.editModeBackup.id, this.editModeBackup))
        this.editMode = false
    }

    saveChanges(event) {
        this.editState[event.target.name] = event.target.value
        console.log('this.editState', this.editState)

        this.orgData = {
            ...this.orgData,
            ...this.editState
        }

        // debounce
        this.store.dispatch(updateOrganization(this.orgData.id, this.orgData))
    }

    /**
     * Render function
     * @return {String}  html output
     */
    render() {

        if (this.isFetching) {

            return html`<sifive-loader></sifive-loader>`;

        }

        const teamList = Object.values(this.teams).map((team) => {

            let courses = [
                ...new Array(3),
            ];

            if (team.courses) {

                courses = [
                    ...team.courses,
                    ...courses,
                ];

            }

            courses = courses.slice(0, 3).map((course) => {

                if (course) {

                    return html`
                        <td class="course">
                        <a href="/course/${course.id}">${course.name}</a>
                        </td>`;

                } else {

                    return html`<td>&nbsp;</td>`;

                }


            });

            return html`
            <tr class="">
                <td class="team">
                    <a href="/team/${team.id}"><b>${team.name}</b></a><br>
                    5 Team Members
                </td>
                ${courses}
            </tr>`;

        });

        let content
        if (this.editMode) {
            content = editOrganization(this.orgData, { endEditMode: () => this.setEditMode(false),
                saveChanges: this.saveChanges, discardChanges: this.discardChanges })
        } else {
            content = viewOrganization(this.orgData, { startEditMode: () => this.setEditMode(true) })
        }

        return html`
            <!-- OrgManagerDashboard -->
            <div class="grid-container">
                ${content}
            </div>
        `;

    }

    /**
     * Callback for redux state changes
     * @param {Object} state current state
     */
    stateChanged(state) {

        this.isFetching = false;
        this.teams = getTeams(state);

        if (Object.values(this.teams).length > 0) {

            Object.values(this.teams).forEach((team) => {

                if (shouldFetchTeamCourses(state, team.id)) {

                    this.store.dispatch(TeamActions.getTeamCourses(team.id));

                }

                this.isFetching = this.isFetching ||
                    isFetchingTeamCourses(state, team.id);

            });

        }

    }

}

export { OrgManagerDashboard };
